import { useCurrentUser } from './useCurrentUser'
import type { Gender } from '../types'

/**
 * Пол текущего пользователя для склонения реплик Луни («ты не показывался» / «не показывалась»).
 *
 * `null` — пол не указан ИЛИ профиль ещё не приехал: и то и другое означает одно и то же для
 * текста — берём нейтральную формулировку. Строка при этом не «мигает» с женской на мужскую,
 * потому что фолбэк не совпадает ни с одной из склонённых форм.
 */
export function useUserGender(): Gender | null {
  const { user } = useCurrentUser()

  return user?.gender ?? null
}
